export default "__VITE_ASSET__C4uyt$IT__"